"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyle = void 0;
const react_1 = require("react");
const helpers_1 = require("./helpers");
const useStyle = (styles, prefix = '_modal-') => {
    return (0, react_1.useCallback)((style) => (0, helpers_1.Style)(style, styles, prefix), [styles, prefix]);
};
exports.useStyle = useStyle;
